function EditableText({ value, onChange, placeholder = "—", mono = false }) {
  return (
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={`w-full border border-slate-200 rounded-md px-2 py-1.5 text-sm text-slate-800 bg-white outline-none focus:border-slate-800 transition-colors ${
        mono ? "font-mono" : ""
      }`}
    />
  );
}

export default EditableText;